<template>
    <div class="term-main">
        <div class="term-container">
            <div class="text-a-left header-main fixed-top">
            <navbar></navbar>
            </div>
            <div class="login-main-wrapper-content">
              <div class="tex-container login-form-main">
                <h2 class="page-title">Login</h2>
                <v-form>
                  <v-alert
                    v-model="alert"
                    dismissible
                    type="success"
                  >
                    You have logged In Successfully.
                  </v-alert>
                  <v-text-field class="form-fields"
                    v-model="username"
                    v-validate="'required|max:10'"
                    :error-messages="errors.collect('username')"
                    data-vv-name="username"
                    label="Username *"
                    required
                    outline
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    type='password'
                    v-validate="'required'"
                    :error-messages="errors.collect('password')"
                    label="Password *"
                    data-vv-name="password"
                    required
                    outline
                  ></v-text-field>
                  <v-btn class="auth-btn" @click="login">Login</v-btn>
                </v-form>
              </div>
            </div>
        
        </div>
    </div>
</template>
<script>
import constants from '@/resources/constants'

export default {

  data: () => ({
    username: '',
    password: '',
    alert: false,
    dictionary: {
      attributes: {
        email: 'E-mail Address'
        // custom attributes
      },
      custom: {
        name: {
          required: () => 'User Name can not be empty',
          max: 'The name field may not be greater than 10 characters'
          // custom messages
        },
      }
    },
  }),
  computed: {
    baseurl() {
      if (constants.staging) {
        return 'https://routeplanner.staging.cycleai.net/'
      } else {
        return 'https://routeplanner.cycleai.net/'
      }
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },

  methods: {
    login () {
      this.$validator.validateAll()
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }, 
        body: JSON.stringify({ username: this.username, password: this.password })
      }
      fetch(this.baseurl + 'api/logIn', requestOptions, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json;charset=UTF-8'
        }
      })
        .then(response => response)
        .then(data => {
          if (data.status == 200) {
            localStorage.setItem('activeUser', this.username)
            this.alert = true
            this.$router.push('/data')
            this.$gtag.event("user_login", {
              event_category: "auth",
              event_label: this.username + " Logged In",
              value: "login"
            });
          }
        })
    },
  }
}
</script>